var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sliding-button', _vm.disabled ? 'disabled_btn': 'enabled_btn'],on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }